import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const mapPointsApiRoutes = {
    list: apiDataManagerBaseURL + "mappoints/",
    listTransportAuthority: apiDataManagerBaseURL + "mappoints/ta/",
    listDraft: apiDataManagerBaseURL + "mappointsdraft/",
    load: apiDataManagerBaseURL + "mappoints/",
    loadDraft: apiDataManagerBaseURL + "mappointsdraft/",
    create: apiDataManagerBaseURL + "mappoints/",
    createTransportAuthority: apiDataManagerBaseURL + "mappoints/ta/",
    createDraft: apiDataManagerBaseURL + "mappointsdraft/",
    update: apiDataManagerBaseURL + "mappoints/",
    updateTransportAuthority: apiDataManagerBaseURL + "mappoints/ta/",
    updateDraft: apiDataManagerBaseURL + "mappointsdraft/",
    delete: apiDataManagerBaseURL + "mappoints/",
    deleteTransportAuthority: apiDataManagerBaseURL + "mappoints/ta/",
    deleteDraft: apiDataManagerBaseURL + "mappointsdraft/"
};

export class MapPointAPI {
    static list(networkEdition, provider = '') {
        const url = new URL(networkEdition, mapPointsApiRoutes.list);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listTransportAuthority() {
        const url = mapPointsApiRoutes.listTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftNetworkEdition, provider = '') {
        const url = new URL(draftNetworkEdition, mapPointsApiRoutes.listDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(networkEdition, id) {
        const url = new URL(`${networkEdition}/${id}`, mapPointsApiRoutes.load);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static loadDraft(draftNetworkEdition, id) {
        const url = new URL(`${draftNetworkEdition}/${id}`, mapPointsApiRoutes.loadDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(networkEdition, mapPoint) {
        const url = new URL(networkEdition, mapPointsApiRoutes.create);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(mapPoint)
        });
    }

    static createTransportAuthority(mapPoint) {
        const url = mapPointsApiRoutes.createTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(mapPoint)
        });
    }

    static createDraft(draftNetworkEdition, mapPoint) {
        const url = new URL(draftNetworkEdition, mapPointsApiRoutes.createDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(mapPoint)
        });
    }

    static update(networkEdition, id, mapPoint) {
        const url = new URL(`${networkEdition}/${id}`, mapPointsApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(mapPoint)
        });
    }

    static updateTransportAuthority(id, mapPoint) {
        const url = new URL(id, mapPointsApiRoutes.updateTransportAuthority);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(mapPoint)
        });
    }

    static updateDraft(draftNetworkEdition, id, mapPoint) {
        const url = new URL(`${draftNetworkEdition}/${id}`, mapPointsApiRoutes.updateDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(mapPoint)
        });
    }

    static delete(networkEdition, id) {
        const url = new URL(`${networkEdition}/${id}`, mapPointsApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteTransportAuthority(id) {
        const url = new URL(id, mapPointsApiRoutes.deleteTransportAuthority);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftNetworkEdition, id) {
        const url = new URL(`${draftNetworkEdition}/${id}`, mapPointsApiRoutes.deleteDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}